// src/components/modalForm/StackedBootstrapModal.js
import React, { useLayoutEffect } from 'react';
import BootstrapModal from 'react-bootstrap/Modal';
import { useModalStack } from '../../contexts/geral/ModalStackContext';

const StackedBootstrapModal = ({
  show,
  style,
  backdropClassName,
  zIndex = 1050,
  enforceFocus = true,
  onKeyDown,
  ...props
}) => {
  const modalLayer = useModalStack(show, zIndex);
  const stackBackdropClassName = `${modalLayer.id}-backdrop`;

  useLayoutEffect(() => {
    if (!show) return undefined;

    const backdrop = document.querySelector(`.${stackBackdropClassName}`);
    if (!backdrop) return undefined;

    const previousZIndex = backdrop.style.zIndex;
    backdrop.style.zIndex = String(modalLayer.backdropZIndex);

    return () => {
      backdrop.style.zIndex = previousZIndex;
    };
  }, [show, stackBackdropClassName, modalLayer.backdropZIndex]);

  return (
    <BootstrapModal
      {...props}
      show={show}
      style={{ ...style, zIndex: modalLayer.zIndex }}
      backdropClassName={[backdropClassName, stackBackdropClassName].filter(Boolean).join(' ')}
      enforceFocus={enforceFocus && modalLayer.isTopModal}
      onKeyDown={(event) => {
        onKeyDown?.(event);
        event.stopPropagation();
      }}
      inert={modalLayer.isTopModal ? undefined : ''}
      data-modal-stack-id={modalLayer.id}
    />
  );
};

StackedBootstrapModal.Body = BootstrapModal.Body;
StackedBootstrapModal.Dialog = BootstrapModal.Dialog;
StackedBootstrapModal.Footer = BootstrapModal.Footer;
StackedBootstrapModal.Header = BootstrapModal.Header;
StackedBootstrapModal.Title = BootstrapModal.Title;
StackedBootstrapModal.TRANSITION_DURATION = BootstrapModal.TRANSITION_DURATION;
StackedBootstrapModal.BACKDROP_TRANSITION_DURATION = BootstrapModal.BACKDROP_TRANSITION_DURATION;

export default StackedBootstrapModal;
